import { MemberService } from "components/member-service/MemberService";
import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import { useProductContext } from "context/ProductContext";
import { redirectFromExitCard } from "utils/giwlUrl";

interface SomethingWentWrongCardProps {
    retryUrl?: string;
}

const SomethingWentWrongCard = ({ retryUrl }: SomethingWentWrongCardProps) => {
    const { isGIWL } = useProductContext();

    return (
        <CardTemplate className="text-base-content min-h-[308px] tablet:min-h-[308px]">
            <div
                data-testid="something-went-wrong-content"
                className="font-medium text-base-content text-base flex flex-col gap-4 pt-10"
            >
                <h2 className="text-xl font-semibold text-base-content text-center">Something Went Wrong</h2>

                <p className="text-base leading-6 tracking-normal text-base-content">
                    We're sorry - it looks like we hit a snag while processing your application.
                </p>

                <p className="text-sm leading-5 tracking-normal text-base-content">
                    You can try again, resume your application later, or contact our support team for help.
                </p>

                <div className="flex justify-center mt-2">
                    <button
                        data-testid="retry-button"
                        className="btn btn-primary h-[36px] w-[69px]"
                        onClick={() => redirectFromExitCard(isGIWL, retryUrl)}
                    >
                        Retry
                    </button>
                </div>

                <MemberService email={false} titleClassName="text-black/90" />

                <HoursOperation className="text-black/90" />
            </div>
        </CardTemplate>
    );
};

export default SomethingWentWrongCard;
